var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"pa-2",attrs:{"cols":"12"}},[_c('span',{staticClass:"font-weight-black primary--text headline"},[_vm._v(" "+_vm._s(_vm.$t(_vm.title))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }